import type { GetTweetById200ReferencedTweetTweetBasicInfoAllOf } from './getTweetById200ReferencedTweetTweetBasicInfoAllOf';
import type { GetTweetById200ReferencedTweetTweetBasicInfoAllOfTwo } from './getTweetById200ReferencedTweetTweetBasicInfoAllOfTwo';

export type GetTweetById200ReferencedTweetTweetBasicInfo = GetTweetById200ReferencedTweetTweetBasicInfoAllOf & GetTweetById200ReferencedTweetTweetBasicInfoAllOfTwo;
